import {
  Row,
  Col,
  Card,
  Modal,
  Avatar,
  Spin,
  TimePicker,
  Tabs,
  Table,
  message,
  Progress,
  Button,
  Tooltip,
  Result,
} from "antd";
import { useState, useEffect, useRef } from "react";
import COLORS from "common/Colors";
import styled from "styled-components";
import { connect, useSelector } from "react-redux";
import {
  getUserInfo,
  getNotificationList,
  getUserRoleId,
  getProfilePic,
  getClientid,
  getMenuList,
  getUserList,
  getHigherOfficials,
} from "redux/selectors";
import { get, startCase, isEmpty } from "lodash";
import { DEVICE } from "common/Device";
import ChangePasswordModal from "organisms/ChangePasswordModal";
import { bindActionCreators } from "redux";
import { clearStore, setIsUserLoggedIn, setProfilePic } from "redux/actions";
import { Switch } from "antd";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ButtonFilled } from "reusableComponent/UIButtons";
import ViewMore from "organisms/ViewMore";
import EditProfile from "organisms/EditMyProfile";
import download from "downloadjs";
import {
  STATUS_CODE,
  getStatutoryFieldLabel,
  MAIN_CLIENT_ID,
  routeToKeyMap,
} from "common/Constants";
import CVGenerator from "./CvGenerator";
import { EditOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import CvDownload from "./Cvdownload";
import { useLocation } from "react-router-dom";

// ---------------------------------------------------------------------
// Route permission helpers - same logic App.js uses (routeToKeyMap + menu
// "access"), kept in this file so the page can check itself.
// ---------------------------------------------------------------------
const hasAccessToKey = (userMenuList, key) =>
  (userMenuList || []).some((menu) => {
    if (menu?.key === key && menu?.access) return true;
    return !!menu?.subMenu?.some((sub) => sub?.key === key && sub?.access);
  });

const matchRoutePath = (routePath, actualPath) => {
  const routeParts = routePath.split("/").filter(Boolean);
  const actualParts = actualPath.split("/").filter(Boolean);
  if (routeParts.length !== actualParts.length) return false;
  return routeParts.every(
    (part, index) => part.startsWith(":") || part === actualParts[index]
  );
};

const getKeysForRoute = (currentPath) => {
  const path =
    currentPath.length > 1 ? currentPath.replace(/\/+$/, "") : currentPath;

  if (routeToKeyMap[path]) {
    const keys = routeToKeyMap[path];
    return Array.isArray(keys) ? keys : [keys];
  }
  for (const [routePath, keys] of Object.entries(routeToKeyMap)) {
    if (matchRoutePath(routePath, path)) {
      return Array.isArray(keys) ? keys : [keys];
    }
  }
  return [];
};

// Unmapped routes are denied, exactly like App.js
const checkRouteAccess = (userMenuList, routePath) => {
  const keys = getKeysForRoute(routePath);
  if (!keys.length) return false;
  return keys.some((key) => hasAccessToKey(userMenuList, key));
};

const StyledProfileContainer = styled.div`
  .right {
    display: flex;
    justify-content: end;
    gap: 20px;
    width: 100%;
    background: #e6e6e6;
    padding: 15px;
    border-radius: 5px;
    @media (max-width: 376px) {
      flex-direction: column;
      font-size: 12px;
    }
  }
  @media ${DEVICE.tablet} {
    .second_half_info {
      margin-top: 15px;
    }
  }
`;

const StyledProfileHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  .header-left {
    display: flex;
  }
`;

const StyledStaffNameContainer = styled.div`
  text-align: center;
  .staff-name {
    font-weight: bold;
    font-size: 1rem;
    padding-top: 10px;
  }
  .location {
    padding-top: 5px;
    svg {
      vertical-align: sub;
      margin-right: 5px;
    }
  }
`;

const StyledTable = styled(Table)`
  padding: 0;
  margin-bottom: 0;
  table {
    table-layout: auto !important;
  }
  .ant-table-wrapper {
    margin-bottom: 0;
    border: 2px solid red !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #e2e2e8;

    border-radius: 8px;
  }
  .ant-table-cell {
    height: 50px;
  }
  .ant-table-thead .ant-table-cell {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    font-family: "DM Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #1f243b;
  }
  .ant-table-tbody > tr > td {
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3019;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .non-white {
    background: #f9f9f9;
  }
  .normal-column {
    white-space: normal;
  }
`;

const StyledAvatar = styled(Avatar)`
  font-size: 3rem;
  height: 100px;
  width: 100px;
  background-color: ${COLORS.PRIMARY};
  vertical-align: middle;
  color: #000;
  border-radius: 10%;
  border: 3px solid black;
  .ant-avatar-string {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const StyledRow = styled(Row)`
  width: 100%;
  display: flex;
  justify-content: center;
  .my-1 {
    display: flex;
    word-wrap: break-word;
  }

  @media screen and (max-width: 430px) {
    padding-left: 8%;
  }
`;

const StyledDocumentModal = styled(Modal)`
  height: 100vh;
  max-width: 80rem;
  padding: 1%;
  width: 100%;

  .ant-modal-content {
    height: 100vh;
    width: 100%;
    box-shadow: none;
  }
  .img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    max-height: 80rem;
    transform: scale(0.85);
  }

  .iframe {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100vh;
    transform: scale(0.85);
  }
  .file_fit {
    width: 100%;
    height: 100%;
  }
  .img_fit {
    max-width: 80vw;
    max-height: 100vh;
  }
`;

const StyledCard1 = styled(Card)`
  width: 100%;
  height: 100%;
  padding: 10px;
  .main_div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    .mb-2 {
      font-size: 18px;
      padding-left: 0px !important;
    }
  }
  @media (max-width: 426px) {
    padding: 0px;
    .main_div {
      gap: 20px;
    }
  }
`;
const StyleRow = styled(Row)`
  .sub_title {
    font-weight: bold;
  }
  @media (max-width: 426px) {
    font-size: 10px;
    .row-gap {
      padding-bottom: 10px;
    }
    .ant-picker-input > input {
      font-size: 10px;
    }
  }
`;
const StyledTab = styled.div`
  .ant-tabs-nav {
    padding-left: 10px;
    border-radius: 5px;
    font-weight: 500;
    color: #000;
  }
  .ant-tabs-tab {
    font-size: 16px;
    &:hover {
      color: ${COLORS.TEXT.PRIMARY};
    }
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.TAB};
    font-weight: bold;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 500;
    font-size: 16px;
  }
  .personal_details_box {
    padding: 10px;
    box-shadow: 0px 3px 6px #00000015;
  }
  .border-style {
    border-bottom: 1px solid #f2f2f2;
    border-width: 90%;
  }
`;

// ---------------------------------------------------------------------
// ACCESS FIX: tab keys used everywhere instead of numeric indexes, so the
// content/buttons always match the tab even when some tabs are hidden.
// ---------------------------------------------------------------------
const TAB_MY_DETAILS = "mydetails";
const TAB_CV_GENERATOR = "cvgenerator";

const PROFILE_TABS = [
  { key: TAB_MY_DETAILS, title: "My Details" },
  { key: TAB_CV_GENERATOR, title: "CV Generator" },
];

// Older navigation (history.push with state.activeTab = 0 / 1) still works
const normalizeTabKey = (tab) => {
  if (tab === 0 || tab === "0") return TAB_MY_DETAILS;
  if (tab === 1 || tab === "1") return TAB_CV_GENERATOR;
  return tab;
};

function MyProfile({
  userInfo,
  userRoleId,
  profilePic,
  ClientId,
  menuList,
  userList,
  setUserLoggedIn,
}) {
  const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [isCvLoading, setIsCvLoading] = useState(false);
  const filteruser = userList?.filter(
    (item) => item?.userid === get(userInfo, "userid", "")
  );
  const [clientData, setClientData] = useState([]);

  // ---------------------------------------------------------------------
  // ACCESS FIX: resolve the "profile" entry from the role's menu list and
  // decide whether this user may open this page at all.
  // ---------------------------------------------------------------------
  const location = useLocation();
  const rawMenulist =
    menuList?.[userRoleId] || Object.values(menuList || {})?.[0] || [];
  const Menulist = Array.isArray(rawMenulist) ? rawMenulist : [];

  // Menu not loaded yet (avoid flashing a "no access" page on first render)
  const isMenuLoaded = Menulist.length > 0;

  const profileMenu = Menulist.find((item) => item?.key === "profile");

  const isProfileAllowed =
    !!profileMenu &&
    profileMenu.access === true &&
    profileMenu.permission?.view === true;

  const profileSubMenu = profileMenu?.subMenu || [];

  const isTabAllowed = (key) =>
    profileSubMenu.some(
      (sub) =>
        sub?.key === key &&
        sub?.access === true &&
        sub?.permission?.view !== false
    );

  // Only tabs that the menu list explicitly allows
  const items = PROFILE_TABS.filter((tab) => isTabAllowed(tab.key)).map(
    (tab) => ({
      id: tab.key,
      label: tab.title,
      component: <></>,
    })
  );

  // Same check App.js runs (routeToKeyMap + menu access), evaluated against
  // the router that actually navigates to this page.
  const isRouteAllowed = checkRouteAccess(Menulist, location.pathname);

  const hasProfileAccess =
    isRouteAllowed && isProfileAllowed && items.length > 0;

  // ---------------------------------------------------------------------
  // Fresh copy of the logged-in user from the getuserbyid API.
  // Used for every value shown on the profile (view + edit form).
  // ---------------------------------------------------------------------
  const [freshUser, setFreshUser] = useState(null);

  const fetchCurrentUser = async () => {
    if (!hasProfileAccess) return; // ACCESS FIX: no API call without access
    if (!ClientId || !userInfo?.userid) return;
    try {
      const result = await CALL_API(
        `getuserbyid?clientid=${ClientId}&userid=${userInfo.userid}`,
        "get"
      );
      if (result?.code === STATUS_CODE.SUCCESS && result?.response) {
        console.log("getuserbyid response:", result.response);
        setFreshUser(result.response);
      }
    } catch (error) {
      console.error("[getuserbyid] error -->", error);
    }
  };

  useEffect(() => {
    fetchCurrentUser();
    // eslint-disable-next-line
  }, [ClientId, userInfo?.userid, hasProfileAccess]);

  // Fresh API data wins; user-list record is only a fallback
  const profileUser = { ...(filteruser?.[0] || {}), ...(freshUser || {}) };

  const capitalize = (v) =>
    v ? String(v).charAt(0).toUpperCase() + String(v).slice(1) : "-";

  const joinValue = (v) =>
    Array.isArray(v) ? v.join(", ") || "-" : v || "-";

  const cvRef = useRef(null);

  // Is the logged-in user's managing office Senegal?
  // managingoffice is normally an array (e.g. ["Senegal"]) but may be a
  // plain string, so handle both, case-insensitively.
  const isSenegalUser = (
    Array.isArray(profileUser?.managingoffice)
      ? profileUser.managingoffice
      : [profileUser?.managingoffice]
  ).some((office) => String(office || "").trim().toLowerCase() === "senegal");

  // Edit buttons on the "My Details" tab are hidden for the main client,
  // EXCEPT for users whose managing office is Senegal.
  // PERMISSION FIX: editing also needs "edit" on Profile -> My Details / CV Generator
  const hasProfileEditPermission = (subKey) =>
    !!Menulist?.find(
      (item) =>
        item?.key === "profile" &&
        item?.subMenu?.find(
          (subItem) => subItem?.key === subKey && subItem?.permission?.edit
        )
    );
  const canEditMyDetails = hasProfileEditPermission(TAB_MY_DETAILS);
  const canEditCv = hasProfileEditPermission(TAB_CV_GENERATOR);
  const showEditProfileButton =
    (ClientId !== MAIN_CLIENT_ID || isSenegalUser) && canEditMyDetails;

  const [attendanceReport, setAttendanceReport] = useState(false);
  const [overtimeReport, setOvertimeReport] = useState(false);
  const [earlyCheckoutReport, setEarlyCheckoutReport] = useState(false);
  const [lateCheckinReport, setLateCheckinReport] = useState(false);
  const [absentReport, setAbsentReport] = useState(false);
  const [displayReportLoader] = useState(false);
  const [attendanceReportId] = useState(0);
  const [overtimeReportId] = useState(0);
  const [earlyCheckoutReportId] = useState(0);
  const [lateCheckinReportId] = useState(0);
  const [absentReportId] = useState(0);
  const [attendanceReportTime, setAttendanceReportTime] = useState();
  const [overtimeReportTime, setOvertimeReportTime] = useState();
  const [earlyCheckoutReportTime, setEarlyCheckoutReportTime] = useState();
  const [lateCheckinReportTime, setLateCheckinReportTime] = useState();
  const [absentReportTime, setAbsentReportTime] = useState();

  const [activeTab, setActiveTab] = useState(
    normalizeTabKey(location.state?.activeTab) ?? TAB_MY_DETAILS
  );

  // ACCESS FIX: if the requested tab is not allowed, fall back to the first
  // allowed one.
  const currentTab = items.some((item) => item.id === activeTab)
    ? activeTab
    : items[0]?.id;

  const [updateState, setUpdateState] = useState("");
  const [EmployeeDetails, setEmployeeDetails] = useState({});
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isLoadingDocuments, toggleLoadingDocuments] = useState(false);
  const [previewType, setPrreviewType] = useState("");
  const [previewURL, setPreviewURL] = useState("");
  const [isCvPreviewOpen, setIsCvPreviewOpen] = useState(false);
  const [cvPreviewUrl, setCvPreviewUrl] = useState("");
  const cvImageReadyRef = useRef(false);

  // State needed by <EditProfile /> (office-supervisor change popup)
  const [terminatePopup, setTeriminatePopup] = useState(false);

  const logoutbtnstyle = { borderColor: "#000", color: "#000" };

  let history = useHistory();

  const handleTabSelect = (key) => {
    const selectedTab = items.find((item) => item.id === key);
    if (selectedTab) {
      setActiveTab(selectedTab.id);
    }
  };

  const calculateProfileCompletion = (user) => {
    if (!user) return 0;

    const totalFields = 8;
    let completed = 0;

    if (user.fullname) completed++;
    if (user.designation) completed++;
    if (user.phoneno) completed++;
    if (user.userid) completed++;
    if (user.backgroundExperience) completed++;
    if (user.expertise && user.expertise.length) completed++;
    if (user?.educationdetails && user?.educationdetails?.length) completed++;
    if (user.workexperience && user.workexperience.length) completed++;

    return Math.round((completed / totalFields) * 100);
  };

  const logoutUser = () => {
    Modal.confirm({
      icon: "",
      content: "Are you sure you want to logout?",
      okText: "Logout",
      cancelText: "Cancel",
      cancelButtonProps: {
        style: logoutbtnstyle,
      },
      onOk: () => {
        setTimeout(() => {
          history.push("/");
          setUserLoggedIn(false);
        }, 500);
      },
    });
  };

  const cvUser = filteruser && filteruser.length > 0 ? filteruser[0] : null;

  const handleGenerateCV = async () => {
    if (!cvRef.current) {
      message.error("CV not ready");
      return;
    }

    setIsCvLoading(true);
    cvImageReadyRef.current = false;

    // Wait for profile image to load (max 8 seconds)
    await new Promise((resolve) => {
      let elapsed = 0;
      const interval = setInterval(() => {
        elapsed += 100;
        if (cvImageReadyRef.current || elapsed >= 8000) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });

    // Extra settle time for fonts/layout
    await new Promise((r) => setTimeout(r, 300));

    try {
      const element = cvRef.current;

      const A4_WIDTH_MM = 210;
      const A4_HEIGHT_MM = 297;
      const MARGIN_MM = 10;
      const SCALE = 2;

      // 1. Render the full CV to one tall canvas
      const canvas = await html2canvas(element, {
        scale: SCALE,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        logging: false,
        imageTimeout: 15000,
        windowWidth: 794,
        width: 794,
        scrollX: 0,
        scrollY: 0,
      });

      const canvasW = canvas.width;
      const canvasH = canvas.height;

      const pxPerMM = canvasW / A4_WIDTH_MM;

      const printableH_MM = A4_HEIGHT_MM - MARGIN_MM * 2;
      const printableH_px = printableH_MM * pxPerMM;

      // 2. Find safe page-break positions (bottom of every <tr>)
      const elementRect = element.getBoundingClientRect();
      const rows = Array.from(element.querySelectorAll("tr"));

      const rowBottoms = rows.map((tr) => {
        const r = tr.getBoundingClientRect();
        return (r.bottom - elementRect.top) * SCALE;
      });

      // 3. Slice canvas at safe positions
      const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });

      let pageStart = 0;
      let isFirstPage = true;

      while (pageStart < canvasH) {
        const idealEnd = pageStart + printableH_px;

        let pageEnd;
        if (idealEnd >= canvasH) {
          pageEnd = canvasH;
        } else {
          const safeBottom = rowBottoms
            .filter((y) => y <= idealEnd && y > pageStart)
            .pop();

          pageEnd = safeBottom ? safeBottom : idealEnd;
        }

        const sliceH = pageEnd - pageStart;

        const tmp = document.createElement("canvas");
        tmp.width = canvasW;
        tmp.height = Math.ceil(sliceH);

        const ctx = tmp.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, tmp.width, tmp.height);
        ctx.drawImage(canvas, 0, pageStart, canvasW, sliceH, 0, 0, canvasW, sliceH);

        const imgData = tmp.toDataURL("image/jpeg", 0.98);
        const sliceH_mm = sliceH / pxPerMM;

        if (!isFirstPage) pdf.addPage();

        pdf.addImage(
          imgData,
          "JPEG",
          MARGIN_MM,
          MARGIN_MM,
          A4_WIDTH_MM - MARGIN_MM * 2,
          sliceH_mm
        );

        pageStart = pageEnd;
        isFirstPage = false;
      }

      const pdfBlob = pdf.output("blob");
      const fileName = `${cvUser?.fullname || "CV"}.pdf`;
      const namedFile = new File([pdfBlob], fileName, { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(namedFile);
      setCvPreviewUrl(blobUrl);
      setIsCvPreviewOpen(true);
    } catch (err) {
      console.error("CV generation failed:", err);
      message.error("Failed to generate CV. Please try again.");
    } finally {
      setIsCvLoading(false);
    }
  };

  const handleChange = async (id, val, time) => {
    CALL_API(`user-preference/${ClientId}/${id}`, "patch", {
      status_name: val,
      user_preference_time: time,
    });
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    await delay(2000);
  };

  // Build the EmployeeDetails object that <EditProfile /> expects.
  // NOTE: the *id-style* keys (officesupervisorid / regionalsupervisorid /
  // appraisalInformation ...) fall back across a few possible casings, since
  // the user-list payload may return them in different cases.
  useEffect(() => {
    const u = freshUser || {};
    setEmployeeDetails({
      userid: u?.userid || "",
      startdate: u?.startdate || "",
      // Date of birth comes from the getuserbyid API (falls back to user list)
      dateofbirth: u.dateofbirth || "",
      enddate: u?.enddate || "",
      bandname: u?.bandname || "",
      bandid: u?.bandid || "",
      overtimestatus: u?.overtimestatus || "",
      salary: u?.salary || "",
      profileurl: u?.profileurl || null,
      profile_url: u?.profile_url || u?.profileurl || null,
      gender: u?.gender || "",
      age: u?.age || "",
      maritalstatus: u?.maritalstatus || "",
      nationality: u?.nationality || "",
      country: u?.country || "",
      facerecognition: u?.facerecognition || "",
      roleid: u?.roleid || "",
      uan: u?.uan || "",
      pan: u?.pan || "",
      address: u?.presentaddress || "",
      postaladdress: u?.postaladdress || "",
      physicaladdress: u?.physicaladdress || u?.presentaddress || "",
      phoneno: u?.phoneno || "",
      personalemailid: u?.personalemailid || "",
      institutename: u?.institutename || "",
      degree: u?.degree ? u?.degree : [],
      specialization: u?.specialization || "",
      yearofcompletion: u?.yearofcompletion || "",
      jobtitle: u?.jobtitle || "",
      professionalsince: u?.professionalsince || "",
      hireddate: u?.hireddate || "",
      relevant: u?.relevant || "",
      national_id: u?.national_id || "",
      nssf: u?.nssf || "",
      krapin: u?.krapin || "",
      housingfundno: u?.housingfundno || "",
      nhif: u?.nhif || "",
      helpmonthlybilling: u?.helpmonthlybilling || "",
      identityinformation: u?.identityinformation || [],
      // Country-specific statutory IDs (MAIN_CLIENT_ID path only - see
      // identityCountryDocuments in EditMyProfile.js).
      tin: u?.tin || "",
      rssb: u?.rssb || "",
      nif: u?.nif || "",
      inss: u?.inss || "",
      nhi: u?.nhi || "",
      wcf: u?.wcf || "",
      employeesponser: u?.employeesponser || "",
      statusname: u?.statusname || "",
      status_id: u?.statusid || "",
      jobdescription: u?.jobdescription || "",
      emergencycontactname: u?.emergencycontactname || "",
      emergencycontactnumber: u?.emergencycontactnumber || "",
      nextofkinrelationship: u?.nextofkinrelationship || "",
      nextofkinpostaladdress: u?.nextofkinpostaladdress || "",
      statusid: u?.statusid || "",
      employementtype: u?.employementtype || "",
      baselocationid: u?.baselocationid || "",
      employeeid: u?.employeeid || "",
      initial: u?.initial || "",
      firstname: u?.firstname || "",
      lastname: u?.lastname || "",
      othernames: u?.othernames || "",
      salutation: u?.salutation || "",
      workpermitno: u?.workpermitno || "",
      workpermitexpirydate: u?.workpermitexpirydate || "",
      competencyQC: u?.competencyQC ? u?.competencyQC : [],
      serviceline: u?.serviceline ? u?.serviceline : [],
      subserviceline: u?.subserviceline ? u?.subserviceline : [],
      competencyrole: u?.competencyrole ? u?.competencyrole : [],
      industry: freshUser?.industry ? freshUser?.industry : [],
      sector: u?.sector ? u?.sector : [],
      secondaryIndustry: u?.secondaryindustry ? u?.secondaryindustry : [],
      secondaryindustry: u?.secondaryindustry ? u?.secondaryindustry : [],
      industryrole: u?.industryrole ? u?.industryrole : [],
      expertise: u?.expertise || "",
      designation: u?.designation || "",
      immediatesupervisor: u?.immediatesupervisor || "",
      grade: u?.grade || "",
      targetchargeability: u?.targetchargeability || "",
      chargeoutrate: u?.chargeoutrate || "",
      greetings: u?.greetings || "",
      professionalcertification: u?.professionalcertification
        ? u?.professionalcertification
        : [],
      lastpromotionlevel: u?.lastpromotionlevel || "",
      dependent: u?.dependent || "",
      companyname: u?.companyname || "",
      educationdetails: u?.educationdetails || [],
      workexperience: u?.workexperience || [],
      professionalcertifications: u?.professionalcertifications
        ? u?.professionalcertifications
        : [],
      practicaltrainings: u?.practicaltrainings || [],
      managingoffice: u?.managingoffice || [],
      organisationlevel: u?.organisationlevel || [],
      manager: u?.manager || "",
      supervisor: u?.supervisor || "",
      lastpromotion: u?.lastpromotion || "",
      levellocationid: u?.levellocationid || "",
      leveldepartmentname: u?.leveldepartmentname || [],
      regionalsupervisor: u?.regionalsupervisor || "",
      regionalcompetencyrole: u?.regionalcompetencyrole || "",
      officesupervisor: u?.officesupervisor || "",
      engagementsupervisor: u?.engagementsupervisor || "",
      oversight: u?.oversight || false,

      // ---- fields required by the "basic" (Edit Employee) form ----
      OfficeSupervisorId:
        u?.OfficeSupervisorId ?? u?.officesupervisorid ?? "none",
      RegionalSupervisorId:
        u?.RegionalSupervisorId ?? u?.regionalsupervisorid ?? "none",
      OfficeSupervisorEmailId:
        u?.OfficeSupervisorEmailId ?? u?.officesupervisoremailid ?? "",
      appraisalInformation:
        u?.appraisalInformation || u?.appraisalinformation || [],
      shiftstarttime: u?.shiftstarttime || "",
      shiftendtime: u?.shiftendtime || "",
      subcluster: u?.subcluster || false,
      subclustercountries: u?.subclustercountries || [],

      // bank / salary (used by their respective edit forms)
      accountname: u?.accountname || "",
      accountno: u?.accountno || "",
      bankname: u?.bankname || "",
      bankbranch: u?.bankbranch || "",
      bankcountry: u?.bankcountry || "",
      bankcode: u?.bankcode || "",
      bankbranchcode: u?.bankbranchcode || "",
      bankswiftcode: u?.bankswiftcode || "",
      grossSalary: u?.grossSalary || "",
      housingAllowance: u?.housingAllowance || "",
      medicalInsurance: u?.medicalInsurance || "",
      pension: u?.pension || "",
      groupLifeInsurance: u?.groupLifeInsurance || "",
      socialSecurityContribution: u?.socialSecurityContribution || "",
      bonus: u?.bonus || "",
      otherCosts: u?.otherCosts || "",
      totalEmploymentCost: u?.totalEmploymentCost || "",
    });
    // eslint-disable-next-line
  }, [userList, freshUser]);

  useEffect(() => {
    if (hasProfileAccess) getShiftList(); // ACCESS FIX: only with access
    // eslint-disable-next-line
  }, [hasProfileAccess]);

  const personalData = [
    { data: "Salutation", value: profileUser.salutation || "-" },
    { data: "First Name", value: profileUser.firstname || "-" },
    { data: "Last Name", value: profileUser.lastname || "-" },
    { data: "Employee ID", value: profileUser.employeeid || "-" },
    { data: "User ID", value: profileUser.userid || "-" },
    { data: "Phone No", value: profileUser.phoneno || "-" },
    { data: "No. of Dependants", value: profileUser.dependent || "-" },
    {
      data: "Date Of Birth",
      value: profileUser.dateofbirth
        ? moment.utc(profileUser.dateofbirth).format("DD-MM-YYYY")
        : "-",
    },
    { data: "Marital Status", value: capitalize(profileUser.maritalstatus) },
    { data: "Greetings", value: profileUser.greetings || "-" },
    { data: "Age", value: profileUser.age || "-" },
    { data: "Gender", value: capitalize(profileUser.gender) },
    { data: "Country", value: capitalize(profileUser.nationality) },
    { data: "Postal Address", value: profileUser.postaladdress || "-" },
    {
      data: "Physical Address",
      value: profileUser.physicaladdress || profileUser.presentaddress || "-",
    },
    {
      data: "Emergency Contact Name",
      value: profileUser.emergencycontactname || "-",
    },
    {
      data: "Emergency Contact Number",
      value: profileUser.emergencycontactnumber || "-",
    },
    {
      data: "Relationship",
      value: profileUser.nextofkinrelationship || "-",
    },
  ];

  const WorkInfoDetails = [
    { data: "Competency/ QC", value: joinValue(profileUser.competencyQC) },
    { data: "Service Line", value: joinValue(profileUser.serviceline) },
    { data: "Sub Serviceline", value: joinValue(profileUser.subserviceline) },
    {
      data: "Office Competency Role",
      value: joinValue(profileUser.competencyrole),
    },
    {
      data: "Regional Competency Supervisor",
      value: profileUser.regionalsupervisor || "-",
    },
    {
      data: "Office Competency Supervisor",
      value: profileUser.officesupervisor || "-",
    },
    {
      data: "Secondary Supervisor",
      value: profileUser.engagementsupervisor || "-",
    },
    { data: "Contracting Company", value: profileUser.companyname || "-" },
    { data: "Primary Industry", value: joinValue(profileUser.industry) },
    { data: "Expertise", value: joinValue(profileUser.expertise) },
    { data: "Industry Role", value: joinValue(profileUser.industryrole) },
    { data: "Designation", value: profileUser.designation || "-" },
    { data: "Grade", value: profileUser.grade || "-" },
    {
      data: "Target Chargeability %",
      value: profileUser.targetchargeability || "-",
    },
    { data: "Charge Out Rate", value: profileUser.chargeoutrate || "-" },
    {
      data: "Last Promotion Date",
      value: profileUser.lastpromotionlevel
        ? moment(profileUser.lastpromotionlevel).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Professional Since",
      value: profileUser.professionalsince
        ? moment(profileUser.professionalsince).format("DD-MM-YYYY")
        : "-",
    },
    { data: "Last Promotion Level", value: profileUser.lastpromotion || "-" },
    { data: "Job Title", value: profileUser.jobtitle || "-" },
    {
      data: "Hired Date",
      value: freshUser?.hireddate
        ? moment(freshUser?.hireddate).format("DD-MM-YYYY")
        : "-",
    },
    { data: "Employee Sponsor", value: profileUser.employeesponser || "-" },
    {
      data: "Status",
      value: String(profileUser.statusid) === "1" ? "Active" : "In Active",
    },
    ...(ClientId !== MAIN_CLIENT_ID
      ? [
        {
          data: getStatutoryFieldLabel(ClientId, "krapin"),
          value: profileUser.krapin || "-",
        },
        {
          data: getStatutoryFieldLabel(ClientId, "housingfundno"),
          value: profileUser.housingfundno || "-",
        },
        {
          data: getStatutoryFieldLabel(ClientId, "nssf"),
          value: profileUser.nssf || "-",
        },
        {
          data: getStatutoryFieldLabel(ClientId, "nhif"),
          value: profileUser.nhif || "-",
        },
        {
          data: getStatutoryFieldLabel(ClientId, "helpmonthlybilling"),
          value: profileUser.helpmonthlybilling || "-",
        },
      ]
      : []),
  ];

  const higherOfficialsList = useSelector((state) => getHigherOfficials(state));
  const financeUsersObj = higherOfficialsList.find(
    (item) => item.roletitle === "financeUsers"
  );

  const userCountry = profileUser.nationality?.toLowerCase();

  const matchedFinanceUser = financeUsersObj?.useremails?.find(
    (item) => item.country?.toLowerCase() === userCountry
  );

  const financeEmail = matchedFinanceUser?.user;

  const matchedUser = userList.find((user) => user.userid === financeEmail);

  const isHeadOffice = profileUser.managingoffice?.some(
    (office) => office?.toLowerCase() === "headoffice"
  );

  const finalPhone = isHeadOffice
    ? profileUser.phoneno
    : matchedUser?.phoneno || "-";

  const handlePreviewClick = async (id, type, document) => {
    const preview = document?.split(".")?.pop();
    toggleLoadingDocuments(true);
    const { code, url } = await CALL_API(`document-list/${ClientId}`, "post", {
      method: "preview-user-document",
      documentId: id,
      identityName: type,
      userId: filteruser?.userid,
    });
    if (code === STATUS_CODE.SUCCESS) {
      if (
        preview === "jpg" ||
        preview === "png" ||
        preview === "jpeg" ||
        preview === "svg" ||
        preview === "pdf"
      ) {
        setIsPreviewModalOpen(true);
        setPreviewURL(url);
      } else {
        download(url);
      }
    } else {
      message.error("Something went wrong!! Please try again.");
    }
    toggleLoadingDocuments(false);
  };

  const getShiftList = async () => {
    try {
      const response = await CALL_FEATCH_API(
        `insyts/engagement?cv=true&userId=${filteruser[0]?.userid}`,
        "get",
        {}
      );

      if (!isEmpty(response)) {
        setClientData(response?.data);
      }
    } catch (error) {
      console.log("[getShiftList] Error-->", error);
    }
  };

  const buildPrefillData = (user) => {
    if (!user) return null;

    return {
      background: user.backgroundExperience || "",
      // expertise can be an array or a comma-separated string
      expertise: Array.isArray(user.expertise)
        ? user.expertise
        : user.expertise?.split?.(",").map((s) => s.trim()).filter(Boolean) || [],
      languages: Array.isArray(user.languages) ? user.languages : [],

      education: (user.educationdetails || []).map((edu) => ({
        title: edu.title || "",
        institute: edu.institutename || "",
        from: edu.fromdate || "",
        to: edu.todate || "",
        examBody: edu.exambody || "",
        awarded: edu.awarded || "",
        attachment: edu.attachment || [],
      })),

      certifications: (user.professionalcertifications || []).map((cert) => ({
        title: cert.title || cert?.certificationname || "",
        type: cert.certificationtype || "",
        from: cert.fromdate || "",
        to: cert.todate || "",
        remark: cert.remarks || "",
        attachment: cert.attachment || [],
      })),
    };
  };

  // CV tab edit.
  // Uses profileUser (user-list record merged with the getuserbyid
  // response), the same object the CV table renders from.
  const handleEdit = () => {
    if (!canEditCv) return;
    const prefillData = buildPrefillData(profileUser);

    if (!prefillData || !profileUser?.userid) {
      message.error("Profile data not available");
      return;
    }

    history.push("cv/edit", { cvData: prefillData });
  };

  // "My Details" tab edit icon -> opens <EditProfile /> with the user's data
  const handleEditProfile = () => {
    if (!canEditMyDetails) return;
    if (!filteruser || filteruser.length === 0) {
      message.error("Profile data not available");
      return;
    }
    setUpdateState("basic");
  };

  const handleReasonCancel = () => setTeriminatePopup(false);

  const PracticalTrainingColumns = [
    {
      title: "Organisation Name",
      dataIndex: "organisationname",
      key: "organisationname",
      width: "5%",
    },
    {
      title: "From",
      dataIndex: "fromdate",
      key: "fromdate",
      width: "5%",
      render: (fromdate) => (fromdate ? moment(fromdate).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "To",
      dataIndex: "todate",
      key: "todate",
      width: "5%",
      render: (todate) => (todate ? moment(todate).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "Position Held",
      dataIndex: "positionheld",
      key: "positionheld",
      align: "center",
      width: "5%",
    },
    {
      title: "Nature of work & Tasks performed or completed",
      dataIndex: "tasksperformed",
      key: "tasksperformed",
      width: "5%",
      className: "normal-column",
      render: (tasksperformed) => <ViewMore value={tasksperformed} count={30} />,
    },
  ];

  const workExperienceColumns = [
    { title: "Company name", dataIndex: "companyname", key: "companyname" },
    { title: "Job Title", dataIndex: "jobtitle", key: "jobtitle" },
    {
      title: "From",
      dataIndex: "fromdate",
      key: "fromdate",
      width: "5%",
      render: (fromdate) => (fromdate ? moment(fromdate).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "To",
      dataIndex: "todate",
      key: "todate",
      width: "5%",
      render: (todate) => (todate ? moment(todate).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "Job Description",
      dataIndex: "jobdescription",
      key: "jobdescription",
      className: "normal-column",
      render: (jobdescription) => <ViewMore value={jobdescription} />,
    },
    {
      title: "Relevant",
      dataIndex: "relevant",
      key: "relevant",
      align: "center",
    },
  ];

  // Uses profileUser so the completion % sees educationdetails etc.
  const profileCompletion = calculateProfileCompletion(profileUser);

  const canEditDetails = (subKey) =>
    Menulist?.find(
      (item) =>
        item?.key === "profile" &&
        item?.subMenu?.find(
          (subItem) => subItem?.key === subKey && subItem?.permission?.edit
        )
    )
      ? false
      : true;

  const renderReportRow = ({
    label,
    enabled,
    setEnabled,
    id,
    time,
    setTime,
    isException = false,
  }) => (
    <StyleRow gutter={16}>
      <Col className="mb-1 row-gap" xs={12} lg={8}>
        {label}
      </Col>
      <Col className="align-center row-gap" xs={12} lg={4}>
        <Switch
          size="small"
          checked={enabled}
          disabled={canEditDetails("reportpreference")}
          onClick={() => {
            handleChange(
              id,
              enabled === true ? "false" : "true",
              time?.format("HH:mm")
            );
            setEnabled(enabled === true ? false : true);
          }}
        />
      </Col>
      <Col className="mb-1" xs={12} lg={6}>
        Period : Daily{" "}
      </Col>
      <Col className="align-center" xs={12} lg={6}>
        <TimePicker
          value={time}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          format={"HH:mm"}
          disabled={canEditDetails("reportpreference")}
          onChange={
            enabled
              ? (val) => {
                handleChange(id, "true", val.format("HH:mm"));
                setTime(moment(val, "HH:mm"));
              }
              : undefined
          }
          clearIcon={null}
        />
      </Col>
    </StyleRow>
  );

  // Extra content shown on the right of the tab bar, per active tab
  const renderTabBarExtraContent = () => {
    // My Details tab -> Edit Profile button
    // (hidden for the main client unless the user's office is Senegal)
    if (currentTab === TAB_MY_DETAILS) {
      if (!showEditProfileButton) return null;
      return (
        <Tooltip title="Edit Profile">
          <ButtonFilled style={{ padding: "0 10px" }} onClick={handleEditProfile}>
            <EditOutlined />
          </ButtonFilled>
        </Tooltip>
      );
    }

    // CV Generator tab
    if (currentTab === TAB_CV_GENERATOR) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          {/* Profile Completion */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              minWidth: "180px",
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>Profile Completion</span>
              <span>{profileCompletion}%</span>
            </div>

            <Progress
              percent={profileCompletion}
              size="small"
              showInfo={false}
              strokeColor={
                profileCompletion < 40
                  ? "#ff4d4f"
                  : profileCompletion < 70
                    ? "#faad14"
                    : "#1ec773"
              }
            />
          </div>

          <Button onClick={handleGenerateCV} loading={isCvLoading}>
            Generate CV
          </Button>

          {/* Disabled until getuserbyid has returned, so the editor never
              receives empty education/certification arrays */}
          {canEditCv && (
            <ButtonFilled
              style={{ padding: "0 10px" }}
              onClick={handleEdit}
              disabled={!freshUser}
            >
              <EditOutlined />
            </ButtonFilled>
          )}
        </div>
      );
    }

    return null;
  };

  // ---------------------------------------------------------------------
  // ACCESS FIX: guards. All hooks are above this point, so returning early
  // here is safe.
  // ---------------------------------------------------------------------
  if (!isMenuLoaded) {
    return (
      <div style={{ textAlign: "center", padding: "80px 0" }}>
        <Spin />
      </div>
    );
  }

  if (!hasProfileAccess) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you don't have permission to access this page."
        extra={
          <Button type="primary" onClick={() => (window.location.href = "/")}>
            Go to Home
          </Button>
        }
      />
    );
  }

  return (
    <>
      {updateState === "" ? (
        <StyledProfileContainer>
          <StyledProfileHeader>
            <div className="header-left">
              <StyledStaffNameContainer>
                {profilePic === null ||
                  profilePic === "" ||
                  Array.isArray(profilePic) ? (
                  <StyledAvatar size="default">
                    {startCase(get(userInfo, "name", "").charAt(0))}
                  </StyledAvatar>
                ) : (
                  <StyledAvatar src={profilePic} size="default"></StyledAvatar>
                )}
              </StyledStaffNameContainer>
              <div className="px-4">
                <b>{profileUser.fullname}</b>
                <br></br>
                <b>Employee Id: {profileUser.employeeid}</b>
                <br></br>
                <b>User Id: </b> {profileUser.userid}
                <br></br>
                <div className="d-flex">
                  <div>
                    <b>Ph: </b>
                    {profileUser.phoneno ? profileUser.phoneno : "-"}
                  </div>
                  <div className="mx-4">|</div>
                  <div>
                    <b>Email: </b>
                    {profileUser.userid}
                  </div>
                </div>
              </div>
            </div>
          </StyledProfileHeader>

          <StyledTab>
            <Tabs
              activeKey={currentTab}
              className="mt-3"
              onChange={handleTabSelect}
              tabBarExtraContent={renderTabBarExtraContent()}
              items={items.map((val) => ({
                label: val.label,
                key: val.id,
                children: val.component,
              }))}
            />

            {currentTab === TAB_MY_DETAILS && (
              <>
                <div className="mb-2 d-flex justify-content-between align-items-center">
                  <b>Personal Information</b>
                </div>
                <Row className="personal_details_box px-3">
                  {personalData.map((data, index) => (
                    <Col xs={24} lg={12} key={index}>
                      <StyledRow className="p-0 m-0">
                        <Col sm={24} md={12} className="px-2 text-wrap">
                          <b className="pb-1 pt-2">{data.data}: </b>
                        </Col>
                        <Col sm={24} md={12} className="text-wrap px-2 p-0 m-0">
                          <p className="m-0 p-1 label_value_Color">{data.value}</p>
                        </Col>
                      </StyledRow>
                    </Col>
                  ))}
                </Row>

                <div className="my-2  d-flex justify-content-between align-items-center">
                  <b className="mt-2">Work Information</b>
                </div>
                <Row className="personal_details_box px-3">
                  {WorkInfoDetails.map((data, index) => (
                    <Col xs={24} lg={12} key={index}>
                      <StyledRow className="p-0 m-0">
                        <Col sm={24} md={12} className="px-2 text-wrap">
                          <b className="pb-1 pt-2">{data.data}: </b>
                        </Col>
                        <Col sm={24} md={12} className="text-wrap px-2 p-0 m-0">
                          <p className="m-0 p-1 label_value_Color">{data.value}</p>
                        </Col>
                      </StyledRow>
                    </Col>
                  ))}
                </Row>

                <div className="mb-2 d-flex justify-content-between align-items-center">
                  <b className="mt-3">Practical Training:</b>
                  {showEditProfileButton && (
                    <Tooltip title="Edit Practical Training">
                      <ButtonFilled
                        className="px-1"
                        onClick={() => setUpdateState("practicaltrainings")}
                      >
                        <EditOutlined />
                      </ButtonFilled>
                    </Tooltip>
                  )}
                </div>
                <StyledTable
                  dataSource={profileUser.practicaltrainings}
                  columns={PracticalTrainingColumns}
                  rowClassName={(record, index) =>
                    index % 2 === 0 ? "" : "non-white"
                  }
                  rowKey="role_id"
                  pagination={false}
                />

                <div className="mb-2 d-flex justify-content-between align-items-center">
                  <b className="mt-3">Work Experience:</b>
                  {showEditProfileButton && (
                    <Tooltip title="Edit Work Experience">
                      <ButtonFilled
                        className="px-1"
                        onClick={() => setUpdateState("workexperience")}
                      >
                        <EditOutlined />
                      </ButtonFilled>
                    </Tooltip>
                  )}
                </div>
                <StyledTable
                  className="mb-5"
                  dataSource={profileUser.workexperience}
                  columns={workExperienceColumns}
                  rowClassName={(record, index) =>
                    index % 2 === 0 ? "" : "non-white"
                  }
                  rowKey="role_id"
                  pagination={false}
                />
              </>
            )}

            {currentTab === TAB_CV_GENERATOR && (
              <>
                <CVGenerator
                  personalData={profileUser}
                  clientData={clientData}
                  isDocumentModalOpen={isDocumentModalOpen}
                  setIsDocumentModalOpen={setIsDocumentModalOpen}
                  selectedDocument={selectedDocument}
                  setSelectedDocument={setSelectedDocument}
                />
              </>
            )}

            {currentTab === "Report Preference" && (
              <Row className="profile-row" gutter={24}>
                <Col md={24} sm={24} xs={24} lg={24}>
                  <StyledCard1 bordered={false}>
                    <Spin spinning={displayReportLoader}>
                      <div className="main_div">
                        <Col className=" mt-1 mb-2" lg={24}>
                          <b>Report Preferences</b>
                        </Col>

                        {renderReportRow({
                          label: "Attendance Report",
                          enabled: attendanceReport,
                          setEnabled: setAttendanceReport,
                          id: attendanceReportId,
                          time: attendanceReportTime,
                          setTime: setAttendanceReportTime,
                        })}
                        {renderReportRow({
                          label: "Overtime Report",
                          enabled: overtimeReport,
                          setEnabled: setOvertimeReport,
                          id: overtimeReportId,
                          time: overtimeReportTime,
                          setTime: setOvertimeReportTime,
                        })}

                        <StyleRow>
                          <Col xs={14} lg={12} className="sub_title">
                            Exception Report
                          </Col>
                        </StyleRow>

                        {renderReportRow({
                          label: "Late Check-in Report",
                          enabled: lateCheckinReport,
                          setEnabled: setLateCheckinReport,
                          id: lateCheckinReportId,
                          time: lateCheckinReportTime,
                          setTime: setLateCheckinReportTime,
                        })}
                        {renderReportRow({
                          label: "Early Check-out Report",
                          enabled: earlyCheckoutReport,
                          setEnabled: setEarlyCheckoutReport,
                          id: earlyCheckoutReportId,
                          time: earlyCheckoutReportTime,
                          setTime: setEarlyCheckoutReportTime,
                        })}
                        {renderReportRow({
                          label: "Absent Report",
                          enabled: absentReport,
                          setEnabled: setAbsentReport,
                          id: absentReportId,
                          time: absentReportTime,
                          setTime: setAbsentReportTime,
                        })}
                      </div>
                    </Spin>
                  </StyledCard1>
                </Col>
              </Row>
            )}
          </StyledTab>
        </StyledProfileContainer>
      ) : (
        <EditProfile
          updateState={updateState}
          setUpdateState={setUpdateState}
          EmployeeDetails={EmployeeDetails}
          pageName="Profile"
          terminatePopup={terminatePopup}
          setTeriminatePopup={setTeriminatePopup}
          reasonopen={terminatePopup}
          handleReasonCancel={handleReasonCancel}
          onProfileUpdated={async () => {
            // refresh the fresh user (DOB etc.) after a save
            await fetchCurrentUser();
            await getShiftList();
          }}
          fromMyProfile
        />
      )}

      <StyledDocumentModal
        centered={true}
        visible={isPreviewModalOpen}
        footer={false}
        keyboard={false}
        width="100%"
        height="100vh"
        onOk={() => setIsPreviewModalOpen(false)}
        onCancel={() => setIsPreviewModalOpen(false)}
      >
        <Spin spinning={isLoadingDocuments}>
          {previewType === "jpg" ||
            previewType === "png" ||
            previewType === "jpeg" ||
            previewType === "svg" ? (
            <div className="img">
              <img src={previewURL} className="img_fit" alt="Preview" />
            </div>
          ) : (
            <embed
              title="PDF Viewer"
              src={previewURL}
              type="application/pdf"
              width="100%"
              height="600px"
              className="pdf-viewer-embed px-5"
            />
          )}
        </Spin>
      </StyledDocumentModal>

      <ChangePasswordModal
        openResetPasswordModal={openResetPasswordModal}
        toggleResetPasswordModal={() =>
          setOpenResetPasswordModal(!openResetPasswordModal)
        }
      ></ChangePasswordModal>

      {/* Off-screen CV used for PDF generation */}
      <div
        style={{
          position: "fixed",
          top: "-9999px",
          left: "-9999px",
          width: "794px",
          minHeight: "1123px",
          background: "#fff",
          overflow: "visible",
          zIndex: -1,
        }}
      >
        <CvDownload
          ref={cvRef}
          cvUser={cvUser}
          clientData={clientData}
          matchedFinanceUser={finalPhone}
          onImageReady={() => {
            cvImageReadyRef.current = true;
          }}
        />
      </div>

      <Modal
        title={`Short Form CV – ${cvUser?.fullname || ""}`}
        open={isCvPreviewOpen}
        footer={null}
        width="80%"
        onCancel={() => {
          URL.revokeObjectURL(cvPreviewUrl);
          setIsCvPreviewOpen(false);
        }}
      >
        <iframe
          src={cvPreviewUrl}
          width="100%"
          height="700px"
          style={{ border: "none" }}
          title={`${cvUser?.fullname || "CV"} - Short Form CV`}
        />
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  notificationList: getNotificationList(state),
  userRoleId: getUserRoleId(state),
  profilePic: getProfilePic(state),
  ClientId: getClientid(state),
  menuList: getMenuList(state),
  userList: getUserList(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveProfilePic: setProfilePic,
      removeStoreData: clearStore,
      setUserLoggedIn: setIsUserLoggedIn,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);